import { render } from "./Verify.vue?vue&type=template&id=ce3b090a"
import script from "./Verify.vue?vue&type=script&lang=ts"
export * from "./Verify.vue?vue&type=script&lang=ts"
script.render = render

export default script